import { NgModule } from '@angular/core';
import { BrandCrosscheckComponent } from './brand-crosscheck.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';

const routes = [
  {
      path     : 'brand-crosscheck',
      component: BrandCrosscheckComponent,
      canActivate: [AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule,
    NgxChartsModule
  ],
  declarations: [
    BrandCrosscheckComponent
  ],
  providers: [
    AuthGuard,
    RoleGuard
  ]
})

export class BrandCrosscheckModule { }
